import {Template} from '@/interface';
import styles from './index.module.scss';
import {ArrowLeftSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import {DocNodePreview} from '@/plugins/AIChatPlugin/AigcChat/DocPreview/NodePreview';
import Button from '@/components/Button';
import {useTemplateJson} from '@/domains/document/hooks/useTemplateJson';
import * as store from '@/store';
import {showTemplatePreviewBuried} from '@/buried/common';
import {useEffect, useMemo, useState} from 'react';
import {STATUS} from '@/Constant';
import contentErrorSvg from '@/assets/svg/contentError.svg?tsx';
import classNames from 'classnames';
import {DocType} from '../../useTemplateList';
import {findFirstDiagramInTrees} from '@/utils/docNodeParse';

interface TemplatePreviewProps {
    onBack: () => void;
    curTemplate: Template;
    onUseTemplate: (template: Template) => any;
}
function TemplatePreview({
    curTemplate,
    onBack,
    onUseTemplate,
}: TemplatePreviewProps) {
    const {content, name, id, rteId, docType} = curTemplate || {};
    const {spaceGuid, groupGuid, repositoryGuid} = store.getCurRepository() || {};
    const [docGuid, setDocGuid] = useState('');

    const {htmlJson, status, onRetry} = useTemplateJson({
        id: id,
        rteId: rteId,
        spaceGuid,
        groupGuid,
        repositoryGuid,
    }, content?.children);

    useEffect(() => {
        showTemplatePreviewBuried();
    }, []);

    useEffect(() => {
        const json = findFirstDiagramInTrees(htmlJson);
        if (json?.docId) {
            setDocGuid(json.docId);
        } else {
            setDocGuid(rteId);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [htmlJson]);

    const isCardTemp = docType === DocType.card;


    const serializeConfig = useMemo(() => {
        return {
            useCover: {
                margin: '0 -20px 0 -26px',
                box: [926, 123],
            },
            hideCard: !isCardTemp,
            unstable_getTransclusionReferenceSync: () => ({}),
        };
    }, [isCardTemp]);

    return <div className={styles.wrap}>
        <div className={styles.head}>
            <Icon className={styles.back} svg={ArrowLeftSvg} size={IconSize.XS} onClick={onBack} />
            <span>{name}</span>
        </div>
        <div className={classNames(styles.content, isCardTemp && styles.topSpace)}>
            {htmlJson && docGuid && <DocNodePreview
                content={htmlJson}
                serializeConfig={serializeConfig}
                docGuid={docGuid}
            />}
            {
                status === STATUS.error
                && <div className={styles.panel}>
                    <Icon svg={contentErrorSvg} size={IconSize.Auto} />
                    <span>加载失败，
                        <span className={styles.retry} onClick={onRetry}>点击重试</span>
                    </span>
                </div>
            }
        </div>
        <div className={styles.footer}>
            <Button className={styles.useBtn} onClick={onUseTemplate(curTemplate)}>使用</Button>
        </div>
    </div>;
}

export default TemplatePreview;
